import { DECLARATIVE_TAGS } from "../config";
import { buildParamsFromTags } from "../functions/buildParamsFromTags";
import { bysideIdToParam } from "../functions/getBysideId";
import { visitorIdToParam } from "../functions/getVisitorId";
import { MODAL_THANKS_HTML } from "../functions/modalThanksHTML";
import { transformToParams } from "../functions/transformToParams";
import fetchJsonp from "fetch-jsonp";

export function generateLead(event, { data }) {
  event.preventDefault();

  if (typeof DFI_client.getCookie == "undefined") {
    window.DFI_client.getCookie = function (name) {
      let match = document.cookie.match(new RegExp(name + "=([^;]+)"));
      if (match) return match[1];
    };
  }

  const DEFAULT_TAGS = buildParamsFromTags({
    declarativeTags: DECLARATIVE_TAGS,
  });
  const TAGS_FROM_USER_FIELDS = transformToParams(data);
  const ID_LEAD = visitorIdToParam();
  const BYSIDE_ID = bysideIdToParam();
  const D1C_TAGS = transformToParams(window.DFI.labels.EDeclaratives);
  const CLIENT_ID = transformToParams({
    clientId: window.DFI_client.getCookie("_ga"),
  });

  const URL = `${DEFAULT_TAGS}${TAGS_FROM_USER_FIELDS}${ID_LEAD}${BYSIDE_ID}${D1C_TAGS}${CLIENT_ID}`;

  const $fundoAmbientalModal = document.querySelector(".fundo-ambiental-modal");
  const $overlay = document.querySelector(".fundo-ambiental-modal__overlay");

  $fundoAmbientalModal?.remove();

  $overlay.innerHTML = MODAL_THANKS_HTML;

  return fetchJsonp(URL, { timeout: 10000 }).then((res) => res.json());
}
